import { useT } from "@/i18n";

export default function Marquee() {
  const { t } = useT();
  const row = [...t.marquee, ...t.marquee];
  return (
    <div
      data-testid="editorial-marquee"
      className="relative overflow-hidden border-y border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-950 py-5 select-none"
    >
      <div className="animate-marquee flex whitespace-nowrap w-max">
        {[0, 1].map((half) => (
          <div key={half} className="flex" aria-hidden={half === 1}>
            {row.map((p, i) => (
              <span
                key={`${half}-${i}`}
                className="font-display font-bold text-lg sm:text-xl tracking-tight text-slate-800 dark:text-slate-200 flex items-center"
              >
                <span className="mx-6">{p}</span>
                <span className="w-1.5 h-1.5 rounded-full bg-slate-500 mx-2" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
